import React from 'react'
import Features from '../components/features/Features'

const ServicesPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 pt-24 pb-12">
      <Features showAll={true} />
    </div>
  )
}

export default ServicesPage
